// extracted by mini-css-extract-plugin
export var content = "index-module--content--cc8ce";
export var img = "index-module--img--683da";
export var link = "index-module--link--0260c";
export var linkText = "index-module--linkText--483d6";
export var root = "index-module--root--5d1b7";
export var subContent = "index-module--subContent--781b3";
export var title = "index-module--title--77232";